/** @typedef {{className:String,youtubeVideoId:String,videoSchemaMarkup:String,apiCall:DR.ApiCall}} T.Quotes.Par */

T.Quotes = Class(
	/**
	 * @lends {T.Quotes#}
	 */
	{
		/**
		 * @param {String} type
		 * @param {T.Quotes.Par} par
		 * @private
		 */
		__construct(type, par = {}) {
			this.type = type;
			this.par = par || {};
			let classNames = ['testimonials'];
			if (par.className) {
				classNames.push(par.className);
			}

			let video = null;
			if (this.par.youtubeVideoId) {
				video = mkE({
					tag: 'iframe',
					src: `https://www.youtube-nocookie.com/embed/${this.par.youtubeVideoId}?rel=0`,
					attr: {
						frameborder: 0,
						allow: 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture',
						allowfullscreen: ''
					}
				});
				classNames.push('w-video');
			}

			this.node = mkE({
				tag: 'div',
				className: classNames.join(' '),
				els: [
					{
						tag: 'div',
						className: 'container',
						els: [
							{
								tag: 'div',
								className: 'h2',
								text: D.Lang.get(`testimonials.${type}.title`)
							},
							D.Lang.exists(`testimonials.${type}.underline`) ? {
								tag: 'p',
								className: 'underline',
								text: D.Lang.get(`testimonials.${type}.underline`)
							} : '',
							this._sliderContaioner = mkE({
								tag: 'div',
								className: 'inner-container',
								els: [
									video
								]
							})
						]
					}
				]
			});

			if (this.par.videoSchemaMarkup) {
				mkE({
					tag: 'script',
					attr: {type: 'application/ld+json'},
					text: JSON.stringify(this.par.videoSchemaMarkup)
				}).append(this.node);
			}

			this._mGetQuotes = new DR.web.GetQuotes();
			this._mGetQuotes.type = this.type;
			this._mGetQuotes.pg = 1;
			this._mGetQuotes.count = 100;
			this._mGetQuotes.select = [
				new DR.roadgames.select.Image().original()
			];
			this._mGetQuotes.onLoad = this._mGetQuotesRe;
			if (this.par.apiCall) {
				this.par.apiCall.addMethod(this._mGetQuotes);
			} else {
				this._mGetQuotes.call();
			}
		},

		_getSliderGap: function() {
			if (D.CSS.brMobile) {
				return 8;
			} else {
				return 36;
			}
		},

		_getSliderPeek: function() {
			if (D.CSS.brMobile) {
				const slideWith = 320;
				const preSlide = window.innerWidth <= 320 ? 0 : 16;
				const afterSlide = this.node.offsetWidth - this._getSliderPerView() * slideWith - preSlide;
				return {before: preSlide, after: afterSlide};
			} else {
				return 0;
			}
		},

		_getSliderPerView: function() {
			if (D.CSS.brMobile) {
				const w = this._getSliderGap() + 320;
				return Math.floor(this.node.offsetWidth / w);
			} else if (this.par.youtubeVideoId) {
				return 1;
			} else {
				return 3;
			}
		},

		_mGetQuotesRe: function() {
			const re = this._mGetQuotes.re;
			let content = [];
			for (let i = 0, l = re.quotes.length; i < l; i++) {
				content.push(new T.Quotes.Quote(re.quotes[i], this.par));
			}

			let par = {
				type: 'carousel',
				startAt: 0,
				gap: this._getSliderGap(),
				peek: this._getSliderPeek(),
				perView: this._getSliderPerView(),
				focusAt: 0,
				dragThreshold: false
			};
			if (re.quotes.length <= 3) {
				par.focusAt = 'center';
			}
			this._slider = new T.Glider({
				config: par,
				content: content
			}).append(this._sliderContaioner);
		},

		onShow() {
			if (this._slider) {
				this._slider.onShow();
			}
		},

		onLeave() {
			if (this._slider) {
				this._slider.onLeave();
			}
		}
	},
	mkE.Base
);

T.Quotes.get = function(type, par = null) {
	return new T.Quotes(type, par);
};

T.Quotes.Quote = Class(
	/**
	 * @lends {T.Quotes.Quote#}
	 */
	{
		/**
		 * @param {DR.web.struct.Quote} data
		 * @param {Object} par
		 * @private
		 */
		__construct(data, par) {
			this.data = data;
			this.par = par;

			let text = D.Lang.get(`testimonials.${this.data.id}.quote`);
			this.node = mkE({
				tag: 'a',
				className: 'testimonial',
				href: D.url(`/testimonials/${data.type}/${data.id}/`),
				els: [
					{
						tag: 'div',
						className: 'info',
						els: [
							{
								tag: 'div',
								className: 'event',
								text: this.par.noEventTitles ? '' : D.Lang.get(`testimonials.${this.data.id}.event`)
							},
							{
								tag: 'div',
								className: 'text ' + (text.length > 140 ? 'text-long' : ''),
								text: text
							},
							{
								tag: 'div',
								className: 'more',
								text: D.Lang.get('testimonials.read_more')
							}
						]
					},
					{
						tag: 'div',
						className: 'footer',
						els: [
							{
								tag: 'div',
								className: 'person',
								els: [
									{
										tag: 'div',
										els: [
											{
												tag: 'h4',
												text: D.Lang.get(`testimonials.${this.data.id}.name`)
											},
											{
												tag: 'div',
												className: 'position',
												text: D.Lang.get(`testimonials.${this.data.id}.position`)
											}
										]
									},
									{
										tag: 'img',
										className: 'image',
										loading: 'lazy',
										alt: D.Lang.get(`testimonials.${this.data.id}.event`),
										src: data.image.original
									}
								]
							}
						]
					}
				]
			});
		}
	},
	mkE.Base
);